import { useEffect } from "react";
import { useSurge } from "../../../hooks/useCases/useSurge";
import { useStylesMUI } from "../../../styles/home/style";
import { TemplateABM } from "../../atomic/templates/TemplateABM";
import { ValidatorInputField } from "../../atomic/atoms/Inputs";
import { required } from "../../../helpers/validations/validators";

export const AbmConceptos = () => {
    const classes = useStylesMUI();
    const surge = useSurge();

    useEffect(() => {
      surge.getAll.conceptos();
    }, []);

    return (
      <div className={classes.root}>
        <TemplateABM
          titles={{
            abm: 'Conceptos Recuperos SUR',
            insert: 'Agregar Concepto',
            update: 'Modificar Concepto',
            delete: 'Eliminar Concepto',
          }}
          data={(data) => ({
            id: data?.id || '',
            descripcion: data?.descripcion || ''
          })}
          formStructure={({ formValues, handleInputChange }) => [
            {
              Component: ValidatorInputField,
              variant: 'outlined',
              label: 'Descripcion',
              name: 'descripcion',
              value: formValues.descripcion,
              onChange: handleInputChange,
              validations: [required],
              grid: { xs: 12 },
            }
          ]}
          dataTable={{
            list: surge.data.conceptos,
            columns: [
              {
                label: 'Descripcion',
                id: 'descripcion',
              }
            ],
          }}
          submit={(formValues, handleClose) => {
            const concepto = {
              id: surge.data.conceptos.find(
                (item) => item.id === formValues.id,
              )?.id,
              descripcion: surge.data.conceptos.find(
                (item) => item.id === formValues.id,
              )?.descripcion,
            };
            if (!!formValues.id)
              surge.update.concepto(formValues, { ...formValues, concepto });
            else surge.insert.concepto(formValues, { ...formValues, concepto });
            handleClose();
          }}
          deleteButton={(id, handleClose) => {
            surge.remove.concepto(id);
            handleClose();
          }}
        />
      </div>
    );
  };
  